import React, { useState } from "react";
import "./FeedbackAttachment.css";
 
import PositiveEmoji from "../../../Images/PositiveEmoji.svg";
import SadEmoji from "../../../Images/SadEmoji.svg";
import NeutralEmoji from "../../../Images/NeutralEmoji.svg";
import PositiveEmojiFill from "../../../Images/PostiveEmojiFill.svg";
import SadEmojiFill from "../../../Images/SadEmojiFill.svg";
import NeutralEmojiFill from "../../../Images/NeutralEmojiFill.svg";
 
import PageLayout from "../../../UiKit/Wizard/Page/PageLayout";
import NavigationButton from "../../../UiKit/Wizard/NavigationButton/NavigationButton";
import SubHeader from "../../../UiKit/Wizard/SubHeader/SubHeader";
import Form from "../../../UiKit/Form/Form";
import WizardLayout from "../../../UiKit/Wizard/WizardLayout/WizardLayout";
import Body from "../../../UiKit/Wizard/Body/Body";
import useWebChat from "../../../Hooks/useWebchat/useWebChat";
import { useLanguage } from "../../../UiKit/Wizard/langugeContext";
import { translations } from "./translations";
 
const FeedbackAttachment = ({ postActivity, activity }) => {
  const { sendMessage } = useWebChat();
 
  const [selectedEmoji, setSelectedEmoji] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [isVisible, setIsVisible] = useState(true);
 
  const { currentLanguage } = useLanguage();
  const currentTranslations = translations[currentLanguage];
  const optionsMap = currentTranslations.feedbackOptions;
  const feedbackTitleMap = currentTranslations.feedbackTitles;
 
  const handleSubmit = () => {
    if (selectedEmoji) {
      postActivity({
        type: "message",
        value: {
          intentName: "provideFeedbackResponse",
          parentIntent: "provideFeedback",
          title: "provideFeedbackResponse",
          NumVal: selectedEmoji,
          MultiLineVal: commentText,
          selectedOptions,
          conversationID: activity.conversation.id,
          timestamp: activity.timestamp,
        },
      });
 
      setIsVisible(false);
 
      postActivity({
        type: "event",
        name: "removeFeedbackCard",
        value: { sourceActivityId: activity.id },
      });
    } else {
      console.error("Please select an emoji before submitting.");
    }
  };
 
  const handleCancelFeedback = () => {
    postActivity({
      type: "event",
      name: "feedbackCancelled",
      value: {
        reason: "user clicked cancel",
      },
    });
 
    setIsVisible(false);
 
    postActivity({
      type: "event",
      name: "removeFeedbackCard",
      value: { sourceActivityId: activity.id },
    });
  };
 
  const handleEmojiSelect = (emoji) => {
    setSelectedEmoji(emoji);
    setSelectedOptions([]);
    setCommentText("");
  };
 
  const handleOptionChange = (label) => {
    setSelectedOptions((prev) => {
      const isSelected = prev.includes(label);
      const updated = isSelected
        ? prev.filter((opt) => opt !== label)
        : [...prev, label];
 
      postActivity({
        type: "event",
        name: "feedbackOptionSelected",
        value: {
          selectedOptions: updated,
          selectedEmoji,
          conversationID: activity.conversation.id,
          timestamp: new Date().toISOString(),
        },
      });
 
      return updated;
    });
  };
 
  if (!isVisible) {
    return <div className="hide-feedback-bubble"></div>;
  }
 
  return (
    <PageLayout>
      <PageLayout.Header>
        <SubHeader
          subHeader={currentTranslations.feedbackTitle}
          className="subHeaderOverride"
          style={{ marginLeft: "24px" }}
        />
      </PageLayout.Header>
 
      <PageLayout.Content>
        <Form>
          <Form.FormGroup>
            <div className="emojiOptions">
              {["happy", "neutral", "sad"].map((mood) => (
                <button
                  key={mood}
                  className={selectedEmoji === mood ? "selected" : ""}
                  onClick={() => handleEmojiSelect(mood)}
                  aria-label={mood}
                >
                  <img
                    src={
                      mood === "happy"
                        ? selectedEmoji === "happy"
                          ? PositiveEmojiFill
                          : PositiveEmoji
                        : mood === "neutral"
                        ? selectedEmoji === "neutral"
                          ? NeutralEmojiFill
                          : NeutralEmoji
                        : selectedEmoji === "sad"
                        ? SadEmojiFill
                        : SadEmoji
                    }
                    alt={
                      mood === "happy"
                        ? "Positive"
                        : mood === "neutral"
                        ? "Neutral"
                        : "Negative"
                    }
                  />
                </button>
              ))}
            </div>
 
            {selectedEmoji && (
              <>
                <Body
                  bodyText={
                    <span className="feedback-title">
                      {feedbackTitleMap[selectedEmoji]}
                    </span>
                  }
                />
 
                <div className="feedbackOptions">
                {optionsMap[selectedEmoji] && optionsMap[selectedEmoji].map((option) => (
 
                    <label key={option.key} className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedOptions.includes(option.label)}
                        onChange={() => handleOptionChange(option.label)}
                      />
                      <span className="checkmark"></span>
                      <span>{option.label}</span>
                    </label>
                  ))}
                </div>
 
                <div className="textarea-wrapper">
                  <textarea
                    placeholder={currentTranslations.feedbackPlaceholder}
                    className="feedback-textarea"
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                  ></textarea>
                </div>
              </>
            )}
          </Form.FormGroup>
        </Form>
      </PageLayout.Content>
 
      <WizardLayout.Navigation>
        {selectedEmoji && (
          <div className="button-group">
            <NavigationButton type="secondary" onClick={handleCancelFeedback}>
              {currentTranslations.cancel}
            </NavigationButton>
            <NavigationButton type="primary" onClick={handleSubmit}>
             {currentTranslations.sendFeedback}
            </NavigationButton>
          </div>
        )}
      </WizardLayout.Navigation>
    </PageLayout>
  );
};
 
export default FeedbackAttachment;
 
 